"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queries = void 0;
exports.queries = {
    vAb0: {
        interpretation: {
            vocab: "htx",
            code: "ab0"
        }
    },
    vRh: {
        interpretation: {
            vocab: "htx",
            code: "rh"
        }
    },
    weight: {
        interpretation: {
            vocab: "htx",
            code: "weight"
        }
    },
    height: {
        interpretation: {
            vocab: "htx",
            code: "height"
        }
    },
    bmi: {
        interpretation: {
            vocab: "htx",
            code: "bmi"
        }
    },
    pvr: {
        interpretation: {
            vocab: "htx",
            code: "pvr"
        }
    },
    patientStatus: {
        interpretation: {
            vocab: "htx",
            code: "patient_status"
        }
    },
    urgency: {
        interpretation: {
            vocab: "htx",
            code: "urgency"
        }
    },
    signedStatementOfConsent: {
        interpretation: {
            vocab: "htx",
            code: "signed_statement_of_consent"
        }
    },
    waitingListStartDate: {
        interpretation: {
            vocab: "htx",
            code: "waiting_list_start_date"
        }
    },
    patientEtId: {
        interpretation: {
            vocab: "htx",
            code: "patient_et_id"
        }
    },
    combinedTransplant: {
        interpretation: {
            vocab: "htx",
            code: "combined_transplant"
        }
    },
    hyperImmunised: {
        interpretation: {
            vocab: "htx",
            code: "hyper_immunised"
        }
    },
    summaryReport: {
        interpretation: {
            vocab: "htx",
            code: "medical_history_summary"
        }
    },
    thoracotomiesSummary: {
        interpretation: {
            vocab: "htx",
            code: "summary_of_thoracotomies"
        }
    },
    heartFailureEtiology: {
        interpretation: {
            vocab: "htx",
            code: "heart_failure_etiology"
        }
    },
    thoracotomies: {
        interpretation: {
            vocab: "htx",
            code: "number_of_thoracotomies"
        }
    },
    nyhaStage: {
        interpretation: {
            vocab: "htx",
            code: "nyha_stage"
        }
    },
    ableTo6mwt: {
        interpretation: {
            vocab: "htx",
            code: "able_to_6MWT"
        }
    },
    "6mwt": {
        interpretation: {
            vocab: "htx",
            code: "6mwt"
        }
    },
    systolicBloodPressure: {
        interpretation: {
            vocab: "htx",
            code: "systolic_blood_pressure"
        }
    },
    diastolicBloodPressure: {
        interpretation: {
            vocab: "htx",
            code: "diastolic_blood_pressure"
        }
    },
    heartRate: {
        interpretation: {
            vocab: "htx",
            code: "heart_rate"
        }
    },
    ekg: {
        interpretation: {
            vocab: "htx",
            code: "ecg_procedure"
        }
    },
    ejectionFraction: {
        interpretation: {
            vocab: "htx",
            code: "ejection_fraction"
        }
    },
    diastolicDysfunction: {
        interpretation: {
            vocab: "htx",
            code: "diastolic_dysfunction"
        }
    },
    edd: {
        interpretation: {
            vocab: "htx",
            code: "edd"
        }
    },
    swt: {
        interpretation: {
            vocab: "htx",
            code: "septal_wall_thickness"
        }
    },
    pwt: {
        interpretation: {
            vocab: "htx",
            code: "posterior_wall_thickness"
        }
    },
    laDiameter1: {
        interpretation: {
            vocab: "htx",
            code: "left_atrial_diameter1"
        }
    },
    laDiameter2: {
        interpretation: {
            vocab: "htx",
            code: "left_atrial_diameter2"
        }
    },
    raDiameter1: {
        interpretation: {
            vocab: "htx",
            code: "right_atrial_diameter1"
        }
    },
    raDiameter2: {
        interpretation: {
            vocab: "htx",
            code: "right_atrial_diameter2"
        }
    },
    aorticRootSize: {
        interpretation: {
            vocab: "htx",
            code: "aortic_root_size"
        }
    },
    aortaAscendensSize: {
        interpretation: {
            vocab: "htx",
            code: "artoa_ascendens_size"
        }
    },
    rvSize: {
        interpretation: {
            vocab: "htx",
            code: "rv_size"
        }
    },
    tapse: {
        interpretation: {
            vocab: "htx",
            code: "TAPSE"
        }
    },
    mitralInsufficiency: {
        interpretation: {
            vocab: "htx",
            code: "mitral_insufficiency"
        }
    },
    aorticInsufficiency: {
        interpretation: {
            vocab: "htx",
            code: "aortic_insufficiency"
        }
    },
    aorticValveGradient: {
        interpretation: {
            vocab: "htx",
            code: "aortic_valve_gradient"
        }
    },
    tricuspidInsufficiency: {
        interpretation: {
            vocab: "htx",
            code: "tricuspid_insufficiency"
        }
    },
    estimatedRightVentricularPeakSystolicPressure: {
        interpretation: {
            vocab: "htx",
            code: "estimated_right_ventricular_peak_systolic_pressure"
        }
    },
    echoDescription: {
        interpretation: {
            vocab: "htx",
            code: "echocardiography_summary"
        }
    },
    coronarography: {
        interpretation: {
            vocab: "htx",
            code: "coronarography_summary"
        }
    },
    cCt: {
        interpretation: {
            vocab: "htx",
            code: "cct_summary"
        }
    },
    cMri: {
        interpretation: {
            vocab: "htx",
            code: "cmri_summary"
        }
    },
    spect: {
        interpretation: {
            vocab: "htx",
            code: "spect_summary"
        }
    },
    cPet: {
        interpretation: {
            vocab: "htx",
            code: "cpet_summary"
        }
    },
    rightHeartCatheterization: {
        interpretation: {
            vocab: "htx",
            code: "right_heart_catheterization"
        }
    },
    ableToSpiroergometry: {
        interpretation: {
            vocab: "htx",
            code: "able_to_spiroergometry"
        }
    },
    cardiopulmonaryStressTest: {
        interpretation: {
            vocab: "htx",
            code: "spiro_fields"
        }
    },
    heartFailureMedicalTherapy: {
        interpretation: {
            vocab: "htx",
            code: "heart_failure_medical_therapy"
        }
    },
    pacemakerTherapy: {
        interpretation: {
            vocab: "htx",
            code: "pacemaker_therapy"
        }
    },
    heartAssistSystemTherapy: {
        interpretation: {
            vocab: "htx",
            code: "heart_asist_system_therapy"
        }
    },
    hospitalizations: {
        interpretation: {
            vocab: "htx",
            code: "hospitalizations"
        }
    },
    vascularSurgeonOpinion: {
        interpretation: {
            vocab: "htx",
            code: "seen_by_vascular_surgeon"
        }
    },
    rheumatologistOpinion: {
        interpretation: {
            vocab: "htx",
            code: "seen_by_rheumatologist"
        }
    },
    radiologistOpinion: {
        interpretation: {
            vocab: "htx",
            code: "seen_by_radiologist"
        }
    },
    oncologistOpinion: {
        interpretation: {
            vocab: "htx",
            code: "seen_by_oncologist"
        }
    },
    neurologistOpinion: {
        interpretation: {
            vocab: "htx",
            code: "seen_by_neurologist"
        }
    },
    nephrologistOpinion: {
        interpretation: {
            vocab: "htx",
            code: "seen_by_nephrologist"
        }
    },
    infectologistOpinion: {
        interpretation: {
            vocab: "htx",
            code: "seen_by_infectologist"
        }
    },
    immunologistOpinion: {
        interpretation: {
            vocab: "htx",
            code: "seen_by_immunologist"
        }
    },
    hepatologistOpinion: {
        interpretation: {
            vocab: "htx",
            code: "seen_by_hepatologist"
        }
    },
    hematologistOpinion: {
        interpretation: {
            vocab: "htx",
            code: "seen_by_hematologist"
        }
    },
    geneticistOpinion: {
        interpretation: {
            vocab: "htx",
            code: "seen_by_geneticist"
        }
    },
    gastroenterologistOpinion: {
        interpretation: {
            vocab: "htx",
            code: "seen_by_gastroenterologist"
        }
    },
    endocrinologistOpinion: {
        interpretation: {
            vocab: "htx",
            code: "seen_by_endocrinologist"
        }
    },
    diabetologistOpinion: {
        interpretation: {
            vocab: "htx",
            code: "seen_by_diabetologist"
        }
    },
    anesthetistOpinion: {
        interpretation: {
            vocab: "htx",
            code: "seen_by_anesthetist"
        }
    },
    chestXray: {
        interpretation: {
            vocab: "htx",
            code: "chest_x_ray_result"
        }
    },
    chestCt: {
        interpretation: {
            vocab: "htx",
            code: "chest_ct_result"
        }
    },
    abdominalUltrasound: {
        interpretation: {
            vocab: "htx",
            code: "abdominal_ultrasound_result"
        }
    },
    urology: {
        interpretation: {
            vocab: "htx",
            code: "urology_result"
        }
    },
    gynecology: {
        interpretation: {
            vocab: "htx",
            code: "gynecology_result"
        }
    },
    psychiatry: {
        interpretation: {
            vocab: "htx",
            code: "psychiatry_result"
        }
    },
    stoolBlood: {
        interpretation: {
            vocab: "htx",
            code: "stool_blood_result"
        }
    },
    urinesediment: {
        interpretation: {
            vocab: "htx",
            code: "urine_sediment_result"
        }
    },
    urineculture: {
        interpretation: {
            vocab: "htx",
            code: "urine_culture_result"
        }
    },
    stoolculture: {
        interpretation: {
            vocab: "htx",
            code: "stool_culture_result"
        }
    },
    carotisDoppler: {
        interpretation: {
            vocab: "htx",
            code: "cartois_doppler_result"
        }
    },
    ophthalmologicExamination: {
        interpretation: {
            vocab: "htx",
            code: "ophthalmologic_examination_result"
        }
    },
    mammography: {
        interpretation: {
            vocab: "htx",
            code: "mammography_result"
        }
    },
    earNoseThroat: {
        interpretation: {
            vocab: "htx",
            code: "ear_nose_throat"
        }
    },
    abi: {
        interpretation: {
            vocab: "htx",
            code: "abi_result"
        }
    },
    proteinuria: {
        interpretation: {
            vocab: "htx",
            code: "proteinuria_result"
        }
    },
    colonoscopy: {
        interpretation: {
            vocab: "htx",
            code: "colonoscopy_result"
        }
    },
    dexa: {
        interpretation: {
            vocab: "htx",
            code: "dexa_result"
        }
    },
    dentalScreening: {
        interpretation: {
            vocab: "htx",
            code: "dental_screening_result"
        }
    },
    dermatology: {
        interpretation: {
            vocab: "htx",
            code: "dermatology_result"
        }
    },
    pulmonology: {
        interpretation: {
            vocab: "htx",
            code: "pulmonology_result"
        }
    },
    fvs: {
        interpretation: {
            vocab: "htx",
            code: "fvs"
        }
    },
    haemoglobin: {
        interpretation: {
            vocab: "htx",
            code: "haemoglobin"
        }
    },
    plateletCount: {
        interpretation: {
            vocab: "htx",
            code: "platelet_count"
        }
    },
    gfr: {
        interpretation: {
            vocab: "htx",
            code: "gfr"
        }
    },
    creatinine: {
        interpretation: {
            vocab: "htx",
            code: "creatinine"
        }
    },
    karbamid: {
        interpretation: {
            vocab: "htx",
            code: "karbamid"
        }
    },
    natrium: {
        interpretation: {
            vocab: "htx",
            code: "natrium"
        }
    },
    potassium: {
        interpretation: {
            vocab: "htx",
            code: "potassium"
        }
    },
    got: {
        interpretation: {
            vocab: "htx",
            code: "got"
        }
    },
    gpt: {
        interpretation: {
            vocab: "htx",
            code: "gpt"
        }
    },
    ggt: {
        interpretation: {
            vocab: "htx",
            code: "ggt"
        }
    },
    alkalinePhosphatase: {
        interpretation: {
            vocab: "htx",
            code: "alkaline_phosphatase"
        }
    },
    bilirubinTotal: {
        interpretation: {
            vocab: "htx",
            code: "bilirubin_total"
        }
    },
    serumGlucose: {
        interpretation: {
            vocab: "htx",
            code: "serum_glucose"
        }
    },
    crp: {
        interpretation: {
            vocab: "htx",
            code: "crp"
        }
    },
    ldh: {
        interpretation: {
            vocab: "htx",
            code: "ldh"
        }
    },
    hgbA1C: {
        interpretation: {
            vocab: "htx",
            code: "hgb_a1_c"
        }
    },
    bilirubinDirect: {
        interpretation: {
            vocab: "htx",
            code: "bilirubin_direct"
        }
    },
    inr: {
        interpretation: {
            vocab: "htx",
            code: "inr"
        }
    },
    pseudocholinesterase: {
        interpretation: {
            vocab: "htx",
            code: "pseudocholinesterase"
        }
    },
    prealbumin: {
        interpretation: {
            vocab: "htx",
            code: "prealbumin"
        }
    },
    tsh: {
        interpretation: {
            vocab: "htx",
            code: "tsh"
        }
    },
    t3: {
        interpretation: {
            vocab: "htx",
            code: "t3"
        }
    },
    t4: {
        interpretation: {
            vocab: "htx",
            code: "t4"
        }
    },
    albumin: {
        interpretation: {
            vocab: "htx",
            code: "serum_albumin"
        }
    },
    bnp: {
        interpretation: {
            vocab: "htx",
            code: "BNP"
        }
    },
    ntProBNP: {
        interpretation: {
            vocab: "htx",
            code: "NT-proBNP"
        }
    },
    coombsDirect: {
        interpretation: {
            vocab: "htx",
            code: "coombs_direct"
        }
    },
    coombsIndirect: {
        interpretation: {
            vocab: "htx",
            code: "coombs_indirect"
        }
    },
    psa: {
        interpretation: {
            vocab: "htx",
            code: "psa"
        }
    },
    praCdc: {
        interpretation: {
            vocab: "htx",
            code: "pra_cdc"
        }
    },
    praLuminex: {
        interpretation: {
            vocab: "htx",
            code: "pra_luminex"
        }
    },
    transplantImmunConcilium: {
        interpretation: {
            vocab: "htx",
            code: "transplant_immun_concilium"
        }
    },
    cmv: {
        interpretation: {
            vocab: "htx",
            code: "cmv_igg"
        }
    },
    ebvSerology: {
        interpretation: {
            vocab: "htx",
            code: "ebv_serology_igg"
        }
    },
    toxoplasmaSerology: {
        interpretation: {
            vocab: "htx",
            code: "toxoplasma_serology_igg"
        }
    },
    varicellaSerology: {
        interpretation: {
            vocab: "htx",
            code: "varicella_serology_igg"
        }
    },
    hsv1Serology: {
        interpretation: {
            vocab: "htx",
            code: "hsv1_serology_igg"
        }
    },
    hsv2Serology: {
        interpretation: {
            vocab: "htx",
            code: "hsv2_serology_igg"
        }
    },
    syphilisScreening: {
        interpretation: {
            vocab: "htx",
            code: "treponema_pallidum_org_screening_procedure"
        }
    },
    hivScreening: {
        interpretation: {
            vocab: "htx",
            code: "hiv_screening"
        }
    },
    hbcAbIgg: {
        interpretation: {
            vocab: "htx",
            code: "hbc_ab_igg"
        }
    },
    hbsAb: {
        interpretation: {
            vocab: "htx",
            code: "hbs_ab"
        }
    },
    hbsAg: {
        interpretation: {
            vocab: "htx",
            code: "hbs_ag"
        }
    },
    hbcAbIgm: {
        interpretation: {
            vocab: "htx",
            code: "hbc_ab_igm"
        }
    },
    hcvScreening: {
        interpretation: {
            vocab: "htx",
            code: "hepa_c_virus_screening"
        }
    },
    fluShot: {
        interpretation: {
            vocab: "htx",
            code: "flu_shot"
        }
    },
    pneumococusVaccination: {
        interpretation: {
            vocab: "htx",
            code: "pneumococus_vaccination"
        }
    },
    hbvVaccination: {
        interpretation: {
            vocab: "htx",
            code: "hbv_vaccination"
        }
    },
    havVaccination: {
        interpretation: {
            vocab: "htx",
            code: "hav_vaccination"
        }
    },
    meningococcusVaccination: {
        interpretation: {
            vocab: "htx",
            code: "meningococcus_vaccination"
        }
    },
    hpvVaccination: {
        interpretation: {
            vocab: "htx",
            code: "hpv_vaccination"
        }
    },
    covidVaccination: {
        interpretation: {
            vocab: "htx",
            code: "covid_vaccination"
        }
    },
    smoking: {
        interpretation: {
            vocab: "htx",
            code: "smoking"
        }
    },
    currentAlcoholUse: {
        interpretation: {
            vocab: "htx",
            code: "current_alcohol_use"
        }
    },
    currentAlcoholAbuse: {
        interpretation: {
            vocab: "htx",
            code: "current_alcohol_abuse"
        }
    },
    anamnesticAlcoholAbuse: {
        interpretation: {
            vocab: "htx",
            code: "anamnestic_alcohol_abuse"
        }
    },
    summaryOfAlcoholUse: {
        interpretation: {
            vocab: "htx",
            code: "summary_of_alcohol_use"
        }
    },
    mentalHealthReview: {
        interpretation: {
            vocab: "htx",
            code: "mental_health_review"
        }
    },
    socialWorkerReview: {
        interpretation: {
            vocab: "htx",
            code: "social_worker_review"
        }
    }
};
